import React from "react";

import { QuestionnaireRow } from "components/AttachmentForm/Components";
import {
  DatePurchasedOptionsToggler,
  NVDOptionToggler,
  NVD_OPTIONS,
} from "components/AttachmentForm/NVDOptionToggles";
import { Input } from "components/Form/FormikControls";
import { Column } from "components/Layout";
import { useFormikContext } from "formik";
import { CandidateDeclarationSuggestion } from "../CandidateDeclarationSuggestions";

export const S0413 = ({ candidateDeclarationId }) => {
  const formikProps = useFormikContext();
  return (
    <Column>
      <QuestionnaireRow>
        <NVDOptionToggler
          labelPosition="top"
          name="declaration.post_breeder_tags"
          label="Post Breeder Tags Applied"
        />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.post_breeder_tags"
        />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <NVDOptionToggler name="declaration.qa_accredited" label="1." />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.qa_accredited"
        />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <NVDOptionToggler
          name="declaration.treated_for_scabby_mouth"
          label="2."
        />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.treated_for_scabby_mouth"
        />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <NVDOptionToggler name="declaration.owned_since_birth" label="3." />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.owned_since_birth"
        />
      </QuestionnaireRow>

      {formikProps.values.declaration.owned_since_birth === NVD_OPTIONS.NO && (
        <QuestionnaireRow>
          <DatePurchasedOptionsToggler
            flexDirection="column"
            name="declaration.owned_since_birth_duration"
            label="How long ago were the animals obtained?"
            labelPosition="top"
          />
          <CandidateDeclarationSuggestion
            candidateDeclarationId={candidateDeclarationId}
            fieldName="declaration.owned_since_birth_duration"
          />
        </QuestionnaireRow>
      )}

      <QuestionnaireRow>
        <NVDOptionToggler name="declaration.veterinary_treatment" label="4." />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.veterinary_treatment"
        />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <NVDOptionToggler
          name="declaration.consumed_material_in_withholding_period"
          label="5."
        />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.consumed_material_in_withholding_period"
        />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <NVDOptionToggler
          name="declaration.fed_feed_containing_animal_fats"
          label="6."
        />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.fed_feed_containing_animal_fats"
        />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <Input name="declaration.additional_information" label="7." />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.additional_information"
        />
      </QuestionnaireRow>
    </Column>
  );
};
